/** @format */

import theme from 'theme';

import {divideBySpaces} from 'helpers/numberHelpers';

interface Props {
  payload: {
    value: number;
  };
  x: number;
  y: number;
  textAnchor: string;
  isLogarithmic: boolean;
}

const CustomYAxis = ({payload, x, y, textAnchor, isLogarithmic}: Props) => {
  const isFixValue = isLogarithmic && payload.value !== 0;
  const value = isFixValue ? Math.pow(10, payload.value) : payload.value;

  return (
    <text
      x={x}
      y={y + 4}
      textAnchor={textAnchor}
      fill={theme.palette.figma_gray_middle_dark?.main}
      fontSize={12}
      fontWeight='400'
    >
      {divideBySpaces(value)}
    </text>
  );
};

export {CustomYAxis};
